import { createFileRoute } from "@tanstack/react-router";
import { ContentTracker } from "@/components/content-tracker";
import { useAuth } from "@/lib/auth-context";
import { useTrackView } from "@/hooks/use-track-view";

export const Route = createFileRoute("/_authenticated/content")({
  head: () => ({
    meta: [
      { title: "Content — CEO Boardroom" },
      {
        name: "description",
        content:
          "Plan, produce, and publish content — then see which pieces actually turn into leads and paid work.",
      },
      { property: "og:title", content: "Content — CEO Boardroom" },
      {
        property: "og:description",
        content: "Move every piece from idea to published, and tie content back to the revenue it creates.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: ContentPage,
});

function ContentPage() {
  const { user } = useAuth();
  useTrackView("content");
  if (!user) return null;

  return (
    <div className="space-y-6 md:space-y-8">
      <div>
        <h1 className="font-display text-3xl font-semibold">Content</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Plan it, make it, publish it — and see which content actually produces revenue.
        </p>
      </div>

      <ContentTracker userId={user.id} />
    </div>
  );
}
